module.exports = "<div>\n  <app-plotly\n    [ranges]=\"ranges\"\n    [inlineNumber]=\"sliceSettings.inline\"\n    [crosslineNumber]=\"sliceSettings.crossline\"\n    [depthSlice]=\"sliceSettings.depth\"\n    style=\"height: 300px\"\n  ></app-plotly>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/model/slice-settings-chart/slice-settings-chart.component.html
// module id = ./src/app/projects/model/slice-settings-chart/slice-settings-chart.component.html
// module chunks = main